import { AppHttpService } from './http/app-http.service';
import { AccountService } from './services/account.service';
import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, Subscription } from 'rxjs';
import { Howl } from 'howler';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styles: [],
})
export class AppComponent {
    constructor(private updates: SwUpdate, private accountService: AccountService, private appHttpService: AppHttpService) {}

    updateChecked = false;

    updateAvailable = false;

    async ngOnInit() {
        this.updates.available.subscribe(() => {
            // Keep the loading indicator active while we reload the page
            this.updateAvailable = true;
            window.location.reload();
        });
        if (this.updates.isEnabled) {
            // This promise will return when the update check is completed,
            // and if an update is available, it will also wait for the update
            // to be downloaded (at which point it calls our callback above and
            // we just need to reload the page to apply it).
            await this.updates.checkForUpdate();
        } else {
            console.log('Service worker updates are disabled.');
        }
        // The update check is done (or service workers are disabled), now
        // we can take the loading indicator down (unless we need to apply an
        // update, but in that case, we have already set this.updateAvailable
        // to true by this point, which keeps the loading indicator active).
        this.updateChecked = true;
    }

    get waitingForUpdates() {
        return !this.updateChecked || this.updateAvailable;
    }
}
